import getNetRecurringBenefitChangeCategoryL0Plus from '@/utils/color/getNetRecurringBenefitCatagoryL0Plus';
import getNetRecurringBenefitChangeCategoryL1Plus from '@/utils/color/getNetRecurringBenefitCatagoryL1Plus';
import getNetRecurringBenefitChangeCategoryL2Plus from '@/utils/color/getNetRecurringBenefitCatagoryL2Plus';
import getNetRecurringBenefitChangeCategoryL3Plus from '@/utils/color/getNetRecurringBenefitCatagoryL3Plus';
import getNetRecurringBenefitChangeCategoryL4Plus from '@/utils/color/getNetRecurringBenefitCatagoryL4Plus';
import { determinePlanningSummary } from '@/utils/planningSummary';
import getComplianceStatus from '../Sort/complianceCheck';
import sortInitiativesByActuals from '../Sort/sortByActual';
import {
  L0ActualDate,
  L1ActualDate,
  L2ActualDate,
  L3ActualDate,
  L4ActualDate,
  L5ActualDate,
  SubmittedForL1PlanDate,
  SubmittedForL2PlanDate,
  SubmittedForL3PlanDate,
  SubmittedForL4PlanDate,
  SubmittedForL5PlanDate,
  L1PlanDate,
  L2PlanDate,
  L3PlanDate,
  L4PlanDate,
  L5PlanDate,
  getCancellationDate,
  getQualitativeKPI,
  L1OriginalPlanDate,
  L5OriginalPlanDate,
  L4OriginalPlanDate,
  L3OriginalPlanDate,
  L2OriginalPlanDate,
  // Import fiscal period functions
  getStageActualYear,
  getStageActualQuarter,
  getStageActualMonth,
  getStageActualWeek,
  getStagePlanYear,
  getStagePlanQuarter,
  getStagePlanMonth,
  getStagePlanWeek,
  getStageOriginalPlanYear,
  getStageOriginalPlanQuarter,
  getStageOriginalPlanMonth,
  getStageOriginalPlanWeek,
  getCancellationYear,
  getCancellationQuarter,
  getCancellationMonth,
  getCancellationWeek,
  getActionItemCreatedOnYear,
  getActionItemCreatedOnQuarter,
  getActionItemCreatedOnMonth,
  getActionItemCreatedOnWeek,
  getActionItemUpdatedOnYear,
  getActionItemUpdatedOnQuarter,
  getActionItemUpdatedOnMonth,
  getActionItemUpdatedOnWeek,
  getMilestoneCreatedOnYear,
  getMilestoneCreatedOnQuarter,
  getMilestoneCreatedOnMonth,
  getMilestoneCreatedOnWeek,
  getMilestoneUpdatedOnYear,
  getMilestoneUpdatedOnQuarter,
  getMilestoneUpdatedOnMonth,
  getMilestoneUpdatedOnWeek,
  getMilestoneStartYear,
  getMilestoneStartQuarter,
  getMilestoneStartMonth,
  getMilestoneStartWeek,
  getMilestoneEndYear,
  getMilestoneEndQuarter,
  getMilestoneEndMonth,
  getMilestoneEndWeek,
  formatDateToYYYYMMDD
} from '@/utils/Sort/checkDate/getDate';
import LLatestActualDate from '@/utils/Sort/checkDate/LLatestActualDate';
import getEarliestMilestoneStartDate from '@/utils/Sort/checkDate/checkMilestoneEarliestStartDate';
import { getLatestMilestoneEndDate } from '@/utils/Sort/checkDate/checkMilestoneLatestEndDate';
import getFrequencyAndDirection from './getFrequencyAndDirection';
import getSubworkstreamCatagory from './getSubworkstreamCatagory';
import getTypeOfImpact from './getTypeOfImpact';
import getImplementationCostCatagory from '../Sort/getImplementationCostCatagory';
import sortInitiativesByActualImpact from '../Sort/sortByActualImpact';
import moment from 'moment';
import planningSummarySimplified from '../planningSummarySimplified';
import groupInitiativesByYearActual from '../Sort/groupInitiativesByYearActual';
import getPlanningSummary from '@/components/Kanban/Workbook/getMilestoneSummary';
import getSimplifiedPlanningSummary from '@/components/Kanban/Workbook/getMilestonePlanningSummary';
import getUniversalKPI from './getUniversalKPI';
import getTypeOfKPI from './getTypeOfKPI';
import getSubsector from './getSubsector';
import getSector from './getSector';

// Helper function to safely convert any value to string for use as object keys
const safeStringify = (value) => {
  if (value === null || value === undefined) {
    return 'Not Set';
  }
  if (value instanceof Date) {
    return moment(value).format('YYYY-MM-DD');
  }
  if (typeof value === 'object') {
    try {
      // Handle moment objects
      if (value && typeof value.format === 'function') {
        return value.format('YYYY-MM-DD');
      }
      return JSON.stringify(value);
    } catch (e) {
      return 'Invalid Object';
    }
  }
  return String(value);
};
const handleColoring = (
  colorByAttribute,
  initiatives,
  result,
  actionResult,
  setInitiativeColors,
  setMilestoneColors,
  setActionItemColors,
  users,
  getRandomColor,
  InitiativePlanningSummary,
  checkToFinanceApprovalStatus,
  getNetRecurringBenefitCategory,
  checkWorkstreamLeadApprovalStatus,
  checkWorkstreamSponsorApprovalStatus,
  checkStrategyAnalystApprovalStatus,
  subworkstream,
  determineStage,
  subsectorData
) => {
  if (colorByAttribute) {
    if (colorByAttribute === 'initiativeName') {
      const colors = {};
      initiatives.forEach((initiative) => {
        if (!colors[initiative.initiativeName]) {
          colors[initiative.initiativeName] = getRandomColor();
        }
      });
      setInitiativeColors(colors);
    } else if (colorByAttribute === 'initiativeNumber') {
      const colors = {};
      initiatives.forEach((initiative) => {
        if (!colors[initiative.initiativeNumber]) {
          colors[initiative.initiativeNumber] = getRandomColor();
        }
      });
      setInitiativeColors(colors);
    } else if (colorByAttribute === 'weeklyStatus') {
      const colors = {};
      initiatives.forEach((initiative) => {
        if (!colors[initiative.weeklyStatus]) {
          colors[initiative.weeklyStatus] = getRandomColor();
        }
      });
      setInitiativeColors(colors);
    } else if (colorByAttribute === 'Stage') {
      const colors = {};
      initiatives.forEach((initiative) => {
        const stage = determineStage(initiative);
        if (!colors[stage]) {
          colors[stage] = getRandomColor();
        }
      });
      setInitiativeColors(colors);
    }
    else if (colorByAttribute === 'Stage (simplified)') {
      const colors = {};
      initiatives.forEach((initiative) => {
        const stage = initiative.stage;
        if (!colors[stage]) {
          colors[stage] = getRandomColor();
        }
      });
      setInitiativeColors(colors);
    }
    else if (
      colorByAttribute === 'workstreamSponsorInfo' ||
      colorByAttribute === 'workstreamLeadInfo' ||
      colorByAttribute === 'initiativeOwnerInfo' ||
      colorByAttribute === 'initiativeOwnerBackupInfo' ||
      colorByAttribute === 'AllowOnlyTo'
    ) {
      const colors = {};
      initiatives.forEach((initiative) => {
        const attributeToColor = initiative[colorByAttribute];
        if (Array.isArray(attributeToColor)) {
          attributeToColor.forEach((person) => {
            const name = `${person?.firstName} ${person?.lastName}`.trim();
            if (name && !colors[name]) {
              colors[name] = getRandomColor();
            }
          });
        }
      });
      setInitiativeColors(colors);
    } else if (colorByAttribute === 'actualKpiUpdateCheck') {
      const colors = {};
      initiatives.forEach((initiative) => {
        const summary = sortInitiativesByActualImpact(initiative, 'actualKpiUpdateCheck');
        if (!colors[summary]) {
          colors[summary] = getRandomColor();
        }
      });
      setInitiativeColors(colors);
    } else if (colorByAttribute === 'actualImpactUpdateCheck') {
      const colors = {};
      initiatives.forEach((initiative) => {
        const summary = sortInitiativesByActualImpact(initiative, 'actualImpactUpdateCheck');
        if (!colors[summary]) {
          colors[summary] = getRandomColor();
        }
      });
      setInitiativeColors(colors);
    } else if (colorByAttribute === '(FY23-24) Actual impact update check') {
      const colors = {};
      initiatives.forEach((initiative) => {
        const summary = groupInitiativesByYearActual(
          initiative,
          '(FY23-24) Actual impact update check'
        );
        if (!colors[summary]) {
          colors[summary] = getRandomColor();
        }
      });
      setInitiativeColors(colors);
    } else if (colorByAttribute === '(FY24-25) Actual impact update check') {
      const colors = {};
      initiatives.forEach((initiative) => {
        const summary = groupInitiativesByYearActual(
          initiative,
          '(FY24-25) Actual impact update check'
        );
        if (!colors[summary]) {
          colors[summary] = getRandomColor();
        }
      });
      setInitiativeColors(colors);
    } else if (colorByAttribute === 'cancellationDate') {
      const colors = {};
      initiatives.forEach((initiative) => {
        const dateValue = getCancellationDate(initiative);
        const summary = safeStringify(dateValue);
        if (!colors[summary]) {
          colors[summary] = getRandomColor();
        }
      });
      setInitiativeColors(colors);
    }
    // Fiscal period color attributes for Cancellation
    else if (colorByAttribute === 'cancellationYear') {
      const colors = {};
      initiatives.forEach((initiative) => {
        const year = getCancellationYear(initiative);
        const summary = year || 'Not Set';
        if (!colors[summary]) {
          colors[summary] = getRandomColor();
        }
      });
      setInitiativeColors(colors);
    }
    else if (colorByAttribute === 'cancellationQuarter') {
      const colors = {};
      initiatives.forEach((initiative) => {
        const quarter = getCancellationQuarter(initiative);
        const summary = quarter || 'Not Set';
        if (!colors[summary]) {
          colors[summary] = getRandomColor();
        }
      });
      setInitiativeColors(colors);
    }
    else if (colorByAttribute === 'cancellationMonth') {
      const colors = {};
      initiatives.forEach((initiative) => {
        const month = getCancellationMonth(initiative);
        const summary = month || 'Not Set';
        if (!colors[summary]) {
          colors[summary] = getRandomColor();
        }
      });
      setInitiativeColors(colors);
    }
    else if (colorByAttribute === 'cancellationWeek') {
      const colors = {};
      initiatives.forEach((initiative) => {
        const week = getCancellationWeek(initiative);
        const summary = week || 'Not Set';
        if (!colors[summary]) {
          colors[summary] = getRandomColor();
        }
      });
      setInitiativeColors(colors);
    }
    // L1 Planned Date and fiscal periods
    else if (colorByAttribute === 'l1PlannedDate') {
      const colors = {};
      initiatives.forEach((initiative) => {
        const dateValue = L1PlanDate(initiative);
        const summary = safeStringify(dateValue);
        if (!colors[summary]) {
          colors[summary] = getRandomColor();
        }
      });
      setInitiativeColors(colors);
    }
    else if (colorByAttribute === 'l1PlanYear') {
      const colors = {};
      initiatives.forEach((initiative) => {
        const year = getStagePlanYear(initiative, 'L1');
        const summary = year || 'Not Set';
        if (!colors[summary]) {
          colors[summary] = getRandomColor();
        }
      });
      setInitiativeColors(colors);
    }
    else if (colorByAttribute === 'l1PlanQuarter') {
      const colors = {};
      initiatives.forEach((initiative) => {
        const quarter = getStagePlanQuarter(initiative, 'L1');
        const summary = quarter || 'Not Set';
        if (!colors[summary]) {
          colors[summary] = getRandomColor();
        }
      });
      setInitiativeColors(colors);
    }
    else if (colorByAttribute === 'l1PlanMonth') {
      const colors = {};
      initiatives.forEach((initiative) => {
        const month = getStagePlanMonth(initiative, 'L1');
        const summary = month || 'Not Set';
        if (!colors[summary]) {
          colors[summary] = getRandomColor();
        }
      });
      setInitiativeColors(colors);
    }
    else if (colorByAttribute === 'l1PlanWeek') {
      const colors = {};
      initiatives.forEach((initiative) => {
        const week = getStagePlanWeek(initiative, 'L1');
        const summary = week || 'Not Set';
        if (!colors[summary]) {
          colors[summary] = getRandomColor();
        }
      });
      setInitiativeColors(colors);
    }
    // L2 Planned Date and fiscal periods
    else if (colorByAttribute === 'l2ForecastDate') {
      const colors = {};
      initiatives.forEach((initiative) => {
        const dateValue = L2PlanDate(initiative);
        const summary = safeStringify(dateValue);
        if (!colors[summary]) {
          colors[summary] = getRandomColor();
        }
      });
      setInitiativeColors(colors);
    }
    else if (colorByAttribute === 'l2PlanYear') {
      const colors = {};
      initiatives.forEach((initiative) => {
        const year = getStagePlanYear(initiative, 'L2');
        const summary = year || 'Not Set';
        if (!colors[summary]) {
          colors[summary] = getRandomColor();
        }
      });
      setInitiativeColors(colors);
    }
    else if (colorByAttribute === 'l2PlanQuarter') {
      const colors = {};
      initiatives.forEach((initiative) => {
        const quarter = getStagePlanQuarter(initiative, 'L2');
        const summary = quarter || 'Not Set';
        if (!colors[summary]) {
          colors[summary] = getRandomColor();
        }
      });
      setInitiativeColors(colors);
    }
    else if (colorByAttribute === 'l2PlanMonth') {
      const colors = {};
      initiatives.forEach((initiative) => {
        const month = getStagePlanMonth(initiative, 'L2');
        const summary = month || 'Not Set';
        if (!colors[summary]) {
          colors[summary] = getRandomColor();
        }
      });
      setInitiativeColors(colors);
    }
    else if (colorByAttribute === 'l2PlanWeek') {
      const colors = {};
      initiatives.forEach((initiative) => {
        const week = getStagePlanWeek(initiative, 'L2');
        const summary = week || 'Not Set';
        if (!colors[summary]) {
          colors[summary] = getRandomColor();
        }
      });
      setInitiativeColors(colors);
    }
    // L3 Planned Date and fiscal periods
    else if (colorByAttribute === 'l3PlannedDate') {
      const colors = {};
      initiatives.forEach((initiative) => {
        const dateValue = L3PlanDate(initiative);
        const summary = safeStringify(dateValue);
        if (!colors[summary]) {
          colors[summary] = getRandomColor();
        }
      });
      setInitiativeColors(colors);
    }
    else if (colorByAttribute === 'l3PlanYear') {
      const colors = {};
      initiatives.forEach((initiative) => {
        const year = getStagePlanYear(initiative, 'L3');
        const summary = year || 'Not Set';
        if (!colors[summary]) {
          colors[summary] = getRandomColor();
        }
      });
      setInitiativeColors(colors);
    }
    else if (colorByAttribute === 'l3PlanQuarter') {
      const colors = {};
      initiatives.forEach((initiative) => {
        const quarter = getStagePlanQuarter(initiative, 'L3');
        const summary = quarter || 'Not Set';
        if (!colors[summary]) {
          colors[summary] = getRandomColor();
        }
      });
      setInitiativeColors(colors);
    }
    else if (colorByAttribute === 'l3PlanMonth') {
      const colors = {};
      initiatives.forEach((initiative) => {
        const month = getStagePlanMonth(initiative, 'L3');
        const summary = month || 'Not Set';
        if (!colors[summary]) {
          colors[summary] = getRandomColor();
        }
      });
      setInitiativeColors(colors);
    }
    else if (colorByAttribute === 'l3PlanWeek') {
      const colors = {};
      initiatives.forEach((initiative) => {
        const week = getStagePlanWeek(initiative, 'L3');
        const summary = week || 'Not Set';
        if (!colors[summary]) {
          colors[summary] = getRandomColor();
        }
      });
      setInitiativeColors(colors);
    }
    // L4 Planned Date and fiscal periods
    else if (colorByAttribute === 'l4PlannedDate') {
      const colors = {};
      initiatives.forEach((initiative) => {
        const dateValue = L4PlanDate(initiative);
        const summary = safeStringify(dateValue);
        if (!colors[summary]) {
          colors[summary] = getRandomColor();
        }
      });
      setInitiativeColors(colors);
    }
    else if (colorByAttribute === 'l4PlanYear') {
      const colors = {};
      initiatives.forEach((initiative) => {
        const year = getStagePlanYear(initiative, 'L4');
        const summary = year || 'Not Set';
        if (!colors[summary]) {
          colors[summary] = getRandomColor();
        }
      });
      setInitiativeColors(colors);
    }
    else if (colorByAttribute === 'l4PlanQuarter') {
      const colors = {};
      initiatives.forEach((initiative) => {
        const quarter = getStagePlanQuarter(initiative, 'L4');
        const summary = quarter || 'Not Set';
        if (!colors[summary]) {
          colors[summary] = getRandomColor();
        }
      });
      setInitiativeColors(colors);
    }
    else if (colorByAttribute === 'l4PlanMonth') {
      const colors = {};
      initiatives.forEach((initiative) => {
        const month = getStagePlanMonth(initiative, 'L4');
        const summary = month || 'Not Set';
        if (!colors[summary]) {
          colors[summary] = getRandomColor();
        }
      });
      setInitiativeColors(colors);
    }
    else if (colorByAttribute === 'l4PlanWeek') {
      const colors = {};
      initiatives.forEach((initiative) => {
        const week = getStagePlanWeek(initiative, 'L4');
        const summary = week || 'Not Set';
        if (!colors[summary]) {
          colors[summary] = getRandomColor();
        }
      });
      setInitiativeColors(colors);
    }
    // L5 Planned Date and fiscal periods
    else if (colorByAttribute === 'l5LatestEstimatedDate') {
      const colors = {};
      initiatives.forEach((initiative) => {
        const dateValue = L5PlanDate(initiative);
        const summary = safeStringify(dateValue);
        if (!colors[summary]) {
          colors[summary] = getRandomColor();
        }
      });
      setInitiativeColors(colors);
    }
    else if (colorByAttribute === 'l5PlanYear') {
      const colors = {};
      initiatives.forEach((initiative) => {
        const year = getStagePlanYear(initiative, 'L5');
        const summary = year || 'Not Set';
        if (!colors[summary]) {
          colors[summary] = getRandomColor();
        }
      });
      setInitiativeColors(colors);
    }
    else if (colorByAttribute === 'l5PlanQuarter') {
      const colors = {};
      initiatives.forEach((initiative) => {
        const quarter = getStagePlanQuarter(initiative, 'L5');
        const summary = quarter || 'Not Set';
        if (!colors[summary]) {
          colors[summary] = getRandomColor();
        }
      });
      setInitiativeColors(colors);
    }
    else if (colorByAttribute === 'l5PlanMonth') {
      const colors = {};
      initiatives.forEach((initiative) => {
        const month = getStagePlanMonth(initiative, 'L5');
        const summary = month || 'Not Set';
        if (!colors[summary]) {
          colors[summary] = getRandomColor();
        }
      });
      setInitiativeColors(colors);
    }
    else if (colorByAttribute === 'l5PlanWeek') {
      const colors = {};
      initiatives.forEach((initiative) => {
        const week = getStagePlanWeek(initiative, 'L5');
        const summary = week || 'Not Set';
        if (!colors[summary]) {
          colors[summary] = getRandomColor();
        }
      });
      setInitiativeColors(colors);
    }
    // L1 Original Planned Date and fiscal periods
    else if (colorByAttribute === 'L1 Original Planned Date') {
      const colors = {};
      initiatives.forEach((initiative) => {
        const dateValue = L1OriginalPlanDate(initiative);
        const summary = safeStringify(dateValue);
        if (!colors[summary]) {
          colors[summary] = getRandomColor();
        }
      });
      setInitiativeColors(colors);
    }
    else if (colorByAttribute === 'L1 Original Plan Year') {
      const colors = {};
      initiatives.forEach((initiative) => {
        const year = getStageOriginalPlanYear(initiative, 'L1');
        const summary = year || 'Not Set';
        if (!colors[summary]) {
          colors[summary] = getRandomColor();
        }
      });
      setInitiativeColors(colors);
    }
    else if (colorByAttribute === 'L1 Original Plan Quarter') {
      const colors = {};
      initiatives.forEach((initiative) => {
        const quarter = getStageOriginalPlanQuarter(initiative, 'L1');
        const summary = quarter || 'Not Set';
        if (!colors[summary]) {
          colors[summary] = getRandomColor();
        }
      });
      setInitiativeColors(colors);
    }
    else if (colorByAttribute === 'L1 Original Plan Month') {
      const colors = {};
      initiatives.forEach((initiative) => {
        const month = getStageOriginalPlanMonth(initiative, 'L1');
        const summary = month || 'Not Set';
        if (!colors[summary]) {
          colors[summary] = getRandomColor();
        }
      });
      setInitiativeColors(colors);
    }
    else if (colorByAttribute === 'L1 Original Plan Week') {
      const colors = {};
      initiatives.forEach((initiative) => {
        const week = getStageOriginalPlanWeek(initiative, 'L1');
        const summary = week || 'Not Set';
        if (!colors[summary]) {
          colors[summary] = getRandomColor();
        }
      });
      setInitiativeColors(colors);
    }
    // L2 Original Planned Date and fiscal periods
    else if (colorByAttribute === 'L2 Original Planned Date') {
      const colors = {};
      initiatives.forEach((initiative) => {
        const dateValue = L2OriginalPlanDate(initiative);
        const summary = safeStringify(dateValue);
        if (!colors[summary]) {
          colors[summary] = getRandomColor();
        }
      });
      setInitiativeColors(colors);
    }
    else if (colorByAttribute === 'L2 Original Plan Year') {
      const colors = {};
      initiatives.forEach((initiative) => {
        const year = getStageOriginalPlanYear(initiative, 'L2');
        const summary = year || 'Not Set';
        if (!colors[summary]) {
          colors[summary] = getRandomColor();
        }
      });
      setInitiativeColors(colors);
    }
    else if (colorByAttribute === 'L2 Original Plan Quarter') {
      const colors = {};
      initiatives.forEach((initiative) => {
        const quarter = getStageOriginalPlanQuarter(initiative, 'L2');
        const summary = quarter || 'Not Set';
        if (!colors[summary]) {
          colors[summary] = getRandomColor();
        }
      });
      setInitiativeColors(colors);
    }
    else if (colorByAttribute === 'L2 Original Plan Month') {
      const colors = {};
      initiatives.forEach((initiative) => {
        const month = getStageOriginalPlanMonth(initiative, 'L2');
        const summary = month || 'Not Set';
        if (!colors[summary]) {
          colors[summary] = getRandomColor();
        }
      });
      setInitiativeColors(colors);
    }
    else if (colorByAttribute === 'L2 Original Plan Week') {
      const colors = {};
      initiatives.forEach((initiative) => {
        const week = getStageOriginalPlanWeek(initiative, 'L2');
        const summary = week || 'Not Set';
        if (!colors[summary]) {
          colors[summary] = getRandomColor();
        }
      });
      setInitiativeColors(colors);
    }
    // L3 Original Planned Date and fiscal periods
    else if (colorByAttribute === 'L3 Original Planned Date') {
      const colors = {};
      initiatives.forEach((initiative) => {
        const dateValue = L3OriginalPlanDate(initiative);
        const summary = safeStringify(dateValue);
        if (!colors[summary]) {
          colors[summary] = getRandomColor();
        }
      });
      setInitiativeColors(colors);
    }
    else if (colorByAttribute === 'L3 Original Plan Year') {
      const colors = {};
      initiatives.forEach((initiative) => {
        const year = getStageOriginalPlanYear(initiative, 'L3');
        const summary = year || 'Not Set';
        if (!colors[summary]) {
          colors[summary] = getRandomColor();
        }
      });
      setInitiativeColors(colors);
    }
    else if (colorByAttribute === 'L3 Original Plan Quarter') {
      const colors = {};
      initiatives.forEach((initiative) => {
        const quarter = getStageOriginalPlanQuarter(initiative, 'L3');
        const summary = quarter || 'Not Set';
        if (!colors[summary]) {
          colors[summary] = getRandomColor();
        }
      });
      setInitiativeColors(colors);
    }
    else if (colorByAttribute === 'L3 Original Plan Month') {
      const colors = {};
      initiatives.forEach((initiative) => {
        const month = getStageOriginalPlanMonth(initiative, 'L3');
        const summary = month || 'Not Set';
        if (!colors[summary]) {
          colors[summary] = getRandomColor();
        }
      });
      setInitiativeColors(colors);
    }
    else if (colorByAttribute === 'L3 Original Plan Week') {
      const colors = {};
      initiatives.forEach((initiative) => {
        const week = getStageOriginalPlanWeek(initiative, 'L3');
        const summary = week || 'Not Set';
        if (!colors[summary]) {
          colors[summary] = getRandomColor();
        }
      });
      setInitiativeColors(colors);
    }
    // L4 Original Planned Date and fiscal periods
    else if (colorByAttribute === 'L4 Original Planned Date') {
      const colors = {};
      initiatives.forEach((initiative) => {
        const dateValue = L4OriginalPlanDate(initiative);
        const summary = safeStringify(dateValue);
        if (!colors[summary]) {
          colors[summary] = getRandomColor();
        }
      });
      setInitiativeColors(colors);
    }
    else if (colorByAttribute === 'L4 Original Plan Year') {
      const colors = {};
      initiatives.forEach((initiative) => {
        const year = getStageOriginalPlanYear(initiative, 'L4');
        const summary = year || 'Not Set';
        if (!colors[summary]) {
          colors[summary] = getRandomColor();
        }
      });
      setInitiativeColors(colors);
    }
    else if (colorByAttribute === 'L4 Original Plan Quarter') {
      const colors = {};
      initiatives.forEach((initiative) => {
        const quarter = getStageOriginalPlanQuarter(initiative, 'L4');
        const summary = quarter || 'Not Set';
        if (!colors[summary]) {
          colors[summary] = getRandomColor();
        }
      });
      setInitiativeColors(colors);
    }
    else if (colorByAttribute === 'L4 Original Plan Month') {
      const colors = {};
      initiatives.forEach((initiative) => {
        const month = getStageOriginalPlanMonth(initiative, 'L4');
        const summary = month || 'Not Set';
        if (!colors[summary]) {
          colors[summary] = getRandomColor();
        }
      });
      setInitiativeColors(colors);
    }
    else if (colorByAttribute === 'L4 Original Plan Week') {
      const colors = {};
      initiatives.forEach((initiative) => {
        const week = getStageOriginalPlanWeek(initiative, 'L4');
        const summary = week || 'Not Set';
        if (!colors[summary]) {
          colors[summary] = getRandomColor();
        }
      });
      setInitiativeColors(colors);
    }
    // L5 Original Planned Date and fiscal periods
    else if (colorByAttribute === 'L5 Original Planned Date') {
      const colors = {};
      initiatives.forEach((initiative) => {
        const dateValue = L5OriginalPlanDate(initiative);
        const summary = safeStringify(dateValue);
        if (!colors[summary]) {
          colors[summary] = getRandomColor();
        }
      });
      setInitiativeColors(colors);
    }
    else if (colorByAttribute === 'L5 Original Plan Year') {
      const colors = {};
      initiatives.forEach((initiative) => {
        const year = getStageOriginalPlanYear(initiative, 'L5');
        const summary = year || 'Not Set';
        if (!colors[summary]) {
          colors[summary] = getRandomColor();
        }
      });
      setInitiativeColors(colors);
    }
    else if (colorByAttribute === 'L5 Original Plan Quarter') {
      const colors = {};
      initiatives.forEach((initiative) => {
        const quarter = getStageOriginalPlanQuarter(initiative, 'L5');
        const summary = quarter || 'Not Set';
        if (!colors[summary]) {
          colors[summary] = getRandomColor();
        }
      });
      setInitiativeColors(colors);
    }
    else if (colorByAttribute === 'L5 Original Plan Month') {
      const colors = {};
      initiatives.forEach((initiative) => {
        const month = getStageOriginalPlanMonth(initiative, 'L5');
        const summary = month || 'Not Set';
        if (!colors[summary]) {
          colors[summary] = getRandomColor();
        }
      });
      setInitiativeColors(colors);
    }
    else if (colorByAttribute === 'L5 Original Plan Week') {
      const colors = {};
      initiatives.forEach((initiative) => {
        const week = getStageOriginalPlanWeek(initiative, 'L5');
        const summary = week || 'Not Set';
        if (!colors[summary]) {
          colors[summary] = getRandomColor();
        }
      });
      setInitiativeColors(colors);
    }
    // L0 Actual Date and fiscal periods
    else if (colorByAttribute === 'l0ActualDate') {
      const colors = {};
      initiatives.forEach((initiative) => {
        const dateValue = L0ActualDate(initiative);
        const summary = safeStringify(dateValue);
        if (!colors[summary]) {
          colors[summary] = getRandomColor();
        }
      });
      setInitiativeColors(colors);
    }
    else if (colorByAttribute === 'l0ActualYear') {
      const colors = {};
      initiatives.forEach((initiative) => {
        const year = getStageActualYear(initiative, 'L0');
        const summary = year || 'Not Set';
        if (!colors[summary]) {
          colors[summary] = getRandomColor();
        }
      });
      setInitiativeColors(colors);
    }
    else if (colorByAttribute === 'l0ActualQuarter') {
      const colors = {};
      initiatives.forEach((initiative) => {
        const quarter = getStageActualQuarter(initiative, 'L0');
        const summary = quarter || 'Not Set';
        if (!colors[summary]) {
          colors[summary] = getRandomColor();
        }
      });
      setInitiativeColors(colors);
    }
    else if (colorByAttribute === 'l0ActualMonth') {
      const colors = {};
      initiatives.forEach((initiative) => {
        const month = getStageActualMonth(initiative, 'L0');
        const summary = month || 'Not Set';
        if (!colors[summary]) {
          colors[summary] = getRandomColor();
        }
      });
      setInitiativeColors(colors);
    }
    else if (colorByAttribute === 'l0ActualWeek') {
      const colors = {};
      initiatives.forEach((initiative) => {
        const week = getStageActualWeek(initiative, 'L0');
        const summary = week || 'Not Set';
        if (!colors[summary]) {
          colors[summary] = getRandomColor();
        }
      });
      setInitiativeColors(colors);
    }
    // L1 Actual Date and fiscal periods
    else if (colorByAttribute === 'l1ActualDate') {
      const colors = {};
      initiatives.forEach((initiative) => {
        const dateValue = L1ActualDate(initiative);
        const summary = safeStringify(dateValue);
        if (!colors[summary]) {
          colors[summary] = getRandomColor();
        }
      });
      setInitiativeColors(colors);
    }
    else if (colorByAttribute === 'l1ActualYear') {
      const colors = {};
      initiatives.forEach((initiative) => {
        const year = getStageActualYear(initiative, 'L1');
        const summary = year || 'Not Set';
        if (!colors[summary]) {
          colors[summary] = getRandomColor();
        }
      });
      setInitiativeColors(colors);
    }
    else if (colorByAttribute === 'l1ActualQuarter') {
      const colors = {};
      initiatives.forEach((initiative) => {
        const quarter = getStageActualQuarter(initiative, 'L1');
        const summary = quarter || 'Not Set';
        if (!colors[summary]) {
          colors[summary] = getRandomColor();
        }
      });
      setInitiativeColors(colors);
    }
    else if (colorByAttribute === 'l1ActualMonth') {
      const colors = {};
      initiatives.forEach((initiative) => {
        const month = getStageActualMonth(initiative, 'L1');
        const summary = month || 'Not Set';
        if (!colors[summary]) {
          colors[summary] = getRandomColor();
        }
      });
      setInitiativeColors(colors);
    }
    else if (colorByAttribute === 'l1ActualWeek') {
      const colors = {};
      initiatives.forEach((initiative) => {
        const week = getStageActualWeek(initiative, 'L1');
        const summary = week || 'Not Set';
        if (!colors[summary]) {
          colors[summary] = getRandomColor();
        }
      });
      setInitiativeColors(colors);
    }
    // L2 Actual Date and fiscal periods
    else if (colorByAttribute === 'l2ActualDate') {
      const colors = {};
      initiatives.forEach((initiative) => {
        const dateValue = L2ActualDate(initiative);
        const summary = safeStringify(dateValue);
        if (!colors[summary]) {
          colors[summary] = getRandomColor();
        }
      });
      setInitiativeColors(colors);
    }
    else if (colorByAttribute === 'l2ActualYear') {
      const colors = {};
      initiatives.forEach((initiative) => {
        const year = getStageActualYear(initiative, 'L2');
        const summary = year || 'Not Set';
        if (!colors[summary]) {
          colors[summary] = getRandomColor();
        }
      });
      setInitiativeColors(colors);
    }
    else if (colorByAttribute === 'l2ActualQuarter') {
      const colors = {};
      initiatives.forEach((initiative) => {
        const quarter = getStageActualQuarter(initiative, 'L2');
        const summary = quarter || 'Not Set';
        if (!colors[summary]) {
          colors[summary] = getRandomColor();
        }
      });
      setInitiativeColors(colors);
    }
    else if (colorByAttribute === 'l2ActualMonth') {
      const colors = {};
      initiatives.forEach((initiative) => {
        const month = getStageActualMonth(initiative, 'L2');
        const summary = month || 'Not Set';
        if (!colors[summary]) {
          colors[summary] = getRandomColor();
        }
      });
      setInitiativeColors(colors);
    }
    else if (colorByAttribute === 'l2ActualWeek') {
      const colors = {};
      initiatives.forEach((initiative) => {
        const week = getStageActualWeek(initiative, 'L2');
        const summary = week || 'Not Set';
        if (!colors[summary]) {
          colors[summary] = getRandomColor();
        }
      });
      setInitiativeColors(colors);
    }
    // L3 Actual Date and fiscal periods
    else if (colorByAttribute === 'l3ActualDate') {
      const colors = {};
      initiatives.forEach((initiative) => {
        const dateValue = L3ActualDate(initiative);
        const summary = safeStringify(dateValue);
        if (!colors[summary]) {
          colors[summary] = getRandomColor();
        }
      });
      setInitiativeColors(colors);
    }
    else if (colorByAttribute === 'l3ActualYear') {
      const colors = {};
      initiatives.forEach((initiative) => {
        const year = getStageActualYear(initiative, 'L3');
        const summary = year || 'Not Set';
        if (!colors[summary]) {
          colors[summary] = getRandomColor();
        }
      });
      setInitiativeColors(colors);
    }
    else if (colorByAttribute === 'l3ActualQuarter') {
      const colors = {};
      initiatives.forEach((initiative) => {
        const quarter = getStageActualQuarter(initiative, 'L3');
        const summary = quarter || 'Not Set';
        if (!colors[summary]) {
          colors[summary] = getRandomColor();
        }
      });
      setInitiativeColors(colors);
    }
    else if (colorByAttribute === 'l3ActualMonth') {
      const colors = {};
      initiatives.forEach((initiative) => {
        const month = getStageActualMonth(initiative, 'L3');
        const summary = month || 'Not Set';
        if (!colors[summary]) {
          colors[summary] = getRandomColor();
        }
      });
      setInitiativeColors(colors);
    }
    else if (colorByAttribute === 'l3ActualWeek') {
      const colors = {};
      initiatives.forEach((initiative) => {
        const week = getStageActualWeek(initiative, 'L3');
        const summary = week || 'Not Set';
        if (!colors[summary]) {
          colors[summary] = getRandomColor();
        }
      });
      setInitiativeColors(colors);
    }
    // L4 Actual Date and fiscal periods
    else if (colorByAttribute === 'l4ActualDate') {
      const colors = {};
      initiatives.forEach((initiative) => {
        const dateValue = L4ActualDate(initiative);
        const summary = safeStringify(dateValue);
        if (!colors[summary]) {
          colors[summary] = getRandomColor();
        }
      });
      setInitiativeColors(colors);
    }
    else if (colorByAttribute === 'l4ActualYear') {
      const colors = {};
      initiatives.forEach((initiative) => {
        const year = getStageActualYear(initiative, 'L4');
        const summary = year || 'Not Set';
        if (!colors[summary]) {
          colors[summary] = getRandomColor();
        }
      });
      setInitiativeColors(colors);
    }
    else if (colorByAttribute === 'l4ActualQuarter') {
      const colors = {};
      initiatives.forEach((initiative) => {
        const quarter = getStageActualQuarter(initiative, 'L4');
        const summary = quarter || 'Not Set';
        if (!colors[summary]) {
          colors[summary] = getRandomColor();
        }
      });
      setInitiativeColors(colors);
    }
    else if (colorByAttribute === 'l4ActualMonth') {
      const colors = {};
      initiatives.forEach((initiative) => {
        const month = getStageActualMonth(initiative, 'L4');
        const summary = month || 'Not Set';
        if (!colors[summary]) {
          colors[summary] = getRandomColor();
        }
      });
      setInitiativeColors(colors);
    }
    else if (colorByAttribute === 'l4ActualWeek') {
      const colors = {};
      initiatives.forEach((initiative) => {
        const week = getStageActualWeek(initiative, 'L4');
        const summary = week || 'Not Set';
        if (!colors[summary]) {
          colors[summary] = getRandomColor();
        }
      });
      setInitiativeColors(colors);
    }
    // L5 Actual Date and fiscal periods
    else if (colorByAttribute === 'l5ActualDate') {
      const colors = {};
      initiatives.forEach((initiative) => {
        const dateValue = L5ActualDate(initiative);
        const summary = safeStringify(dateValue);
        if (!colors[summary]) {
          colors[summary] = getRandomColor();
        }
      });
      setInitiativeColors(colors);
    }
    else if (colorByAttribute === 'l5ActualYear') {
      const colors = {};
      initiatives.forEach((initiative) => {
        const year = getStageActualYear(initiative, 'L5');
        const summary = year || 'Not Set';
        if (!colors[summary]) {
          colors[summary] = getRandomColor();
        }
      });
      setInitiativeColors(colors);
    }
    else if (colorByAttribute === 'l5ActualQuarter') {
      const colors = {};
      initiatives.forEach((initiative) => {
        const quarter = getStageActualQuarter(initiative, 'L5');
        const summary = quarter || 'Not Set';
        if (!colors[summary]) {
          colors[summary] = getRandomColor();
        }
      });
      setInitiativeColors(colors);
    }
    else if (colorByAttribute === 'l5ActualMonth') {
      const colors = {};
      initiatives.forEach((initiative) => {
        const month = getStageActualMonth(initiative, 'L5');
        const summary = month || 'Not Set';
        if (!colors[summary]) {
          colors[summary] = getRandomColor();
        }
      });
      setInitiativeColors(colors);
    }
    else if (colorByAttribute === 'l5ActualWeek') {
      const colors = {};
      initiatives.forEach((initiative) => {
        const week = getStageActualWeek(initiative, 'L5');
        const summary = week || 'Not Set';
        if (!colors[summary]) {
          colors[summary] = getRandomColor();
        }
      });
      setInitiativeColors(colors);
    }
    // Submission Dates
    else if (colorByAttribute === 'subForL1ApprovDate') {
      const colors = {};
      initiatives.forEach((initiative) => {
        const dateValue = SubmittedForL1PlanDate(initiative);
        const summary = safeStringify(dateValue);
        if (!colors[summary]) {
          colors[summary] = getRandomColor();
        }
      });
      setInitiativeColors(colors);
    } else if (colorByAttribute === 'subForL2ApprovDate') {
      const colors = {};
      initiatives.forEach((initiative) => {
        const dateValue = SubmittedForL2PlanDate(initiative);
        const summary = safeStringify(dateValue);
        if (!colors[summary]) {
          colors[summary] = getRandomColor();
        }
      });
      setInitiativeColors(colors);
    } else if (colorByAttribute === 'subForL3ApprovDate') {
      const colors = {};
      initiatives.forEach((initiative) => {
        const dateValue = SubmittedForL3PlanDate(initiative);
        const summary = safeStringify(dateValue);
        if (!colors[summary]) {
          colors[summary] = getRandomColor();
        }
      });
      setInitiativeColors(colors);
    } else if (colorByAttribute === 'subForL4ApprovDate') {
      const colors = {};
      initiatives.forEach((initiative) => {
        const dateValue = SubmittedForL4PlanDate(initiative);
        const summary = safeStringify(dateValue);
        if (!colors[summary]) {
          colors[summary] = getRandomColor();
        }
      });
      setInitiativeColors(colors);
    } else if (colorByAttribute === 'subForL5ApprovDate') {
      const colors = {};
      initiatives.forEach((initiative) => {
        const dateValue = SubmittedForL5PlanDate(initiative);
        const summary = safeStringify(dateValue);
        if (!colors[summary]) {
          colors[summary] = getRandomColor();
        }
      });
      setInitiativeColors(colors);
    } else if (colorByAttribute === 'latestActualDateAllLGates') {
      const colors = {};
      initiatives.forEach((initiative) => {
        const dateValue = LLatestActualDate(initiative);
        const summary = safeStringify(dateValue);
        if (!colors[summary]) {
          colors[summary] = getRandomColor();
        }
      });
      setInitiativeColors(colors);
    } else if (colorByAttribute === 'latestMilestoneEndDate') {
      const colors = {};
      initiatives.forEach((initiative) => {
        const dateValue = getLatestMilestoneEndDate(initiative);
        const summary = safeStringify(dateValue);
        if (!colors[summary]) {
          colors[summary] = getRandomColor();
        }
      });
      setInitiativeColors(colors);
    } else if (colorByAttribute === 'earliestMilestoneStartDate') {
      const colors = {};
      initiatives.forEach((initiative) => {
        const dateValue = getEarliestMilestoneStartDate(initiative);
        const summary = safeStringify(dateValue);
        if (!colors[summary]) {
          colors[summary] = getRandomColor();
        }
      });
      setInitiativeColors(colors);
    } else if (colorByAttribute === 'workstreamSponsorWorkstream') {
      const colors = {};
      initiatives.forEach((initiative) => {
        if (Array.isArray(initiative.workstreamSponsorWorkstream)) {
          initiative.workstreamSponsorWorkstream.forEach((ws) => {
            if (ws?.workstreamName && !colors[ws.workstreamName]) {
              colors[ws.workstreamName] = getRandomColor();
            }
          });
        }
      });
      setInitiativeColors(colors);
    } else if (colorByAttribute === 'workstreamLeadSubworkstream') {
      const colors = {};
      initiatives.forEach((initiative) => {
        if (Array.isArray(initiative.workstreamLeadSubworkstream)) {
          initiative.workstreamLeadSubworkstream.forEach((ws) => {
            if (ws?.subworkstreamName && !colors[ws.subworkstreamName]) {
              colors[ws.subworkstreamName] = getRandomColor();
            }
          });
        }
      });
      setInitiativeColors(colors);
    } else if (colorByAttribute === 'crossFunctionalSupportWorkstreamInfo') {
      const colors = {};
      initiatives.forEach((initiative) => {
        if (Array.isArray(initiative.crossFunctionalSupportWorkstreamInfo)) {
          const crossFunctionalSupportWorkstream = initiative.crossFunctionalSupportWorkstreamInfo?.[0]?.subworkstreamName;
          const key = crossFunctionalSupportWorkstream ? String(crossFunctionalSupportWorkstream) : '<not set>';
          if (!colors[key]) {
            colors[key] = getRandomColor();
          }
        }
      });
      setInitiativeColors(colors);
    } else if (colorByAttribute === 'planningSummary') {
      const colors = {};
      initiatives.forEach((initiative) => {
        const summary = InitiativePlanningSummary(initiative);
        if (!colors[summary.planningStatus]) {
          colors[summary.planningStatus] = getRandomColor();
        }
      });
      setInitiativeColors(colors);
    }
    else if (colorByAttribute === 'Description') {
      const colors = {};
      initiatives.forEach((initiative) => {
        const description = initiative.description;
        if (!colors[description]) {
          colors[description] = getRandomColor();
        }
      });
      setInitiativeColors(colors);
    }
    else if (colorByAttribute === 'Planning summary (simplified)') {
      const colors = {};
      initiatives.forEach((initiative) => {
        const summary = planningSummarySimplified(initiative);
        if (!colors[summary]) {
          colors[summary] = getRandomColor();
        }
      });
      setInitiativeColors(colors);
    }
    else if (colorByAttribute === 'Finance lead pending approval?') {
      const colors = {};
      initiatives.forEach((initiative) => {
        const summary = checkToFinanceApprovalStatus(initiative);
        if (!colors[summary]) {
          colors[summary] = getRandomColor();
        }
      });
      setInitiativeColors(colors);
    } else if (colorByAttribute === 'Strategy analyst pending approval?') {
      const colors = {};
      initiatives.forEach((initiative) => {
        const summary = checkStrategyAnalystApprovalStatus(initiative);
        if (!colors[summary]) {
          colors[summary] = getRandomColor();
        }
      });
      setInitiativeColors(colors);
    } else if (colorByAttribute === 'Net recurring benefits range (latest estimate, annualized)') {
      const colors = {};
      initiatives.forEach((initiative) => {
        const summary = getNetRecurringBenefitCategory(initiative);
        if (!colors[summary]) {
          colors[summary] = getRandomColor();
        }
      });
      setInitiativeColors(colors);
    } else if (colorByAttribute === 'Future implementation costs range') {
      const colors = {};
      initiatives.forEach((initiative) => {
        const summary = getImplementationCostCatagory(initiative);
        if (!colors[summary]) {
          colors[summary] = getRandomColor();
        }
      });
      setInitiativeColors(colors);
    } else if (colorByAttribute === 'Workstream Lead pending approval?') {
      const colors = {};
      initiatives.forEach((initiative) => {
        const summary = checkWorkstreamLeadApprovalStatus(initiative);
        if (!colors[summary]) {
          colors[summary] = getRandomColor();
        }
      });
      setInitiativeColors(colors);
    } else if (colorByAttribute === 'Workstream Sponsor pending approval?') {
      const colors = {};
      initiatives.forEach((initiative) => {
        const summary = checkWorkstreamSponsorApprovalStatus(initiative);
        if (!colors[summary]) {
          colors[summary] = getRandomColor();
        }
      });
      setInitiativeColors(colors);
    } else if (colorByAttribute === 'Pipeline weekly variance (L0+)') {
      const colors = {};
      initiatives.forEach((initiative) => {
        const summary = getNetRecurringBenefitChangeCategoryL0Plus(initiative);
        if (!colors[summary]) {
          colors[summary] = getRandomColor();
        }
      });
      setInitiativeColors(colors);
    } else if (colorByAttribute === 'Pipeline weekly variance (L1+)') {
      const colors = {};
      initiatives.forEach((initiative) => {
        const summary = getNetRecurringBenefitChangeCategoryL1Plus(initiative);
        if (!colors[summary]) {
          colors[summary] = getRandomColor();
        }
      });
      setInitiativeColors(colors);
    } else if (colorByAttribute === 'Pipeline weekly variance (L2+)') {
      const colors = {};
      initiatives.forEach((initiative) => {
        const summary = getNetRecurringBenefitChangeCategoryL2Plus(initiative);
        if (!colors[summary]) {
          colors[summary] = getRandomColor();
        }
      });
      setInitiativeColors(colors);
    } else if (colorByAttribute === 'Pipeline weekly variance (L3+)') {
      const colors = {};
      initiatives.forEach((initiative) => {
        const summary = getNetRecurringBenefitChangeCategoryL3Plus(initiative);
        if (!colors[summary]) {
          colors[summary] = getRandomColor();
        }
      });
      setInitiativeColors(colors);
    } else if (colorByAttribute === 'Pipeline weekly variance (L4+)') {
      const colors = {};
      initiatives.forEach((initiative) => {
        const summary = getNetRecurringBenefitChangeCategoryL4Plus(initiative);
        if (!colors[summary]) {
          colors[summary] = getRandomColor();
        }
      });
      setInitiativeColors(colors);
    } else if (colorByAttribute === 'initiativeNumber - initiativeName') {
      const color = {};
      initiatives.forEach((initiative) => {
        const summary = `${initiative.initiativeNumber} - ${initiative.initiativeName}`;
        if (!color[summary]) {
          color[summary] = getRandomColor();
        }
      });
      setInitiativeColors(color);
    } else if (colorByAttribute === 'Has qualitative KPI?') {
      const colors = {};
      initiatives.forEach((initiative) => {
        const summary = getQualitativeKPI(initiative);
        if (!colors[summary]) {
          colors[summary] = getRandomColor();
        }
      });
      setInitiativeColors(colors);
    }
    else if (colorByAttribute === 'Number of Attachment') {
      const colors = {};
      initiatives.forEach((initiative) => {
        const summury = initiative.attachmentCount;
        if (!colors[summury]) {
          colors[summury] = getRandomColor();
        }
      });
      setInitiativeColors(colors);
    } else if (colorByAttribute === 'selectedForToMeetingDescusion') {
      const colors = {};
      initiatives.forEach((initiative) => {
        const summary = initiative.selectedForToMeetingDescusion ? 'Yes' : 'No';
        if (!colors[summary]) {
          colors[summary] = getRandomColor();
        }
      });
      setInitiativeColors(colors);
    } else if (colorByAttribute === 'hasFinancialImpact') {
      const colors = {};
      initiatives.forEach((initiative) => {
        const summary = initiative.hasFinancialImpact ? 'Yes' : 'No';
        if (!colors[summary]) {
          colors[summary] = getRandomColor();
        }
      });
      setInitiativeColors(colors);
    }
    else if (colorByAttribute === 'forSpecificCustomer') {
      const colors = {};
      initiatives.forEach((initiative) => {
        const customerSpecific = initiative.forSpecificCustomer ? 'Yes' : 'No';
        if (!colors[customerSpecific]) {
          colors[customerSpecific] = getRandomColor();
        }
      });
      setInitiativeColors(colors);
    }
    else if (colorByAttribute === 'segmentalPBT') {
      const colors = {};
      initiatives.forEach((initiative) => {
        const isSegmentalPBT = initiative?.segmentalPBT ? 'Yes' : 'No';
        if (!colors[isSegmentalPBT]) {
          colors[isSegmentalPBT] = getRandomColor();
        }
      });
      setInitiativeColors(colors)
    }
    else if (colorByAttribute === 'L3 date compliance check (forecast vs planned date)') {
      const colors = {};
      initiatives.forEach((initiative) => {
        const summary = getComplianceStatus(initiative, 'L3');
        if (!colors[summary]) {
          colors[summary] = getRandomColor();
        }
      });
      setInitiativeColors(colors);
    } else if (colorByAttribute === 'L4 date compliance check (forecast vs planned date)') {
      const colors = {};
      initiatives.forEach((initiative) => {
        const summary = getComplianceStatus(initiative, 'L4');
        if (!colors[summary]) {
          colors[summary] = getRandomColor();
        }
      });
      setInitiativeColors(colors);
    } else if (colorByAttribute === 'TO Finance Lead') {
      const colors = {};
      const toFinance = users.find((u) => u.role.name === 'TO Finance');
      const financeName = `${toFinance.firstName} ${toFinance.lastName}`;
      if (!colors[financeName]) {
        colors[financeName] = getRandomColor();
      }
      setInitiativeColors(colors);
    } else if (colorByAttribute === 'frequencyAndDirectionBinned') {
      const colors = {};
      initiatives.forEach((initiative) => {
        const summary = getFrequencyAndDirection(initiative);
        if (!colors[summary]) {
          colors[summary] = getRandomColor();
        }
      });
      setInitiativeColors(colors);
    } else if (colorByAttribute === 'whosePandL') {
      const colors = {};
      initiatives.forEach((initiative) => {
        const summary = getSubworkstreamCatagory(initiative, subworkstream);
        if (!colors[summary]) {
          colors[summary] = getRandomColor();
        }
      });
      setInitiativeColors(colors);
    }
    else if (colorByAttribute === 'sectorInfo') {
      const colors = {};
      initiatives.forEach((initiative) => {
        const sector = getSector(initiative, subsectorData);
        if (!colors[sector]) {
          colors[sector] = getRandomColor();
        }
      });
      setInitiativeColors(colors);
    }
    else if (colorByAttribute === 'subsectorInfo') {
      const colors = {};
      initiatives.forEach((initiative) => {
        const sector = getSubsector(initiative, subsectorData);
        if (!colors[sector]) {
          colors[sector] = getRandomColor();
        }
      });
      setInitiativeColors(colors);
    }
    else if (colorByAttribute === 'type') {
      const colors = {};
      initiatives.forEach((initiative) => {
        const type = initiative.type;
        if (!colors[type]) {
          colors[type] = getRandomColor();
        }
      })
      setInitiativeColors(colors)
    }
    else if (colorByAttribute === 'size') {
      const colors = {};
      initiatives.forEach((initiative) => {
        const type = initiative.size;
        if (!colors[type]) {
          colors[type] = getRandomColor();
        }
      })
      setInitiativeColors(colors)
    }
    else if (colorByAttribute === 'segment') {
      const colors = {};
      initiatives.forEach((initiative) => {
        const type = initiative.segment;
        if (!colors[type]) {
          colors[type] = getRandomColor();
        }
      })
      setInitiativeColors(colors)
    }
    else if (colorByAttribute === 'initiativeCategory') {
      const colors = {};
      initiatives.forEach((initiative) => {
        const type = initiative.initiativeCategory;
        if (!colors[type]) {
          colors[type] = getRandomColor();
        }
      })
      setInitiativeColors(colors)
    }
    else if (colorByAttribute === 'typeOfImpact') {
      const colors = {};
      initiatives.forEach((initiative) => {
        const summary = getTypeOfImpact(initiative);
        if (!colors[summary]) {
          colors[summary] = getRandomColor();
        }
      });
      setInitiativeColors(colors);
    }
    else if (colorByAttribute === 'UniversalKPI') {
      const colors = {};
      initiatives.forEach((initiative) => {
        const kpiSummary = getUniversalKPI(initiative);
        if (!colors[kpiSummary]) {
          colors[kpiSummary] = getRandomColor();
        }
      });
      setInitiativeColors(colors);
    }
    else if (colorByAttribute === 'TypeOfKPI') {
      const colors = {};
      initiatives.forEach((initiative) => {
        const kpiSummary = getTypeOfKPI(initiative);
        if (!colors[kpiSummary]) {
          colors[kpiSummary] = getRandomColor();
        }
      });
      setInitiativeColors(colors);
    }
    else if (colorByAttribute === 'actualImpactUpdateCheck') {
      const colors = {};
      initiatives.forEach((initiative) => {
        const summary = sortInitiativesByActuals(initiative, 'actualImpactUpdateCheck');
        if (!colors[summary]) {
          colors[summary] = getRandomColor();
        }
      });
      setInitiativeColors(colors);
    } else {
      setInitiativeColors({});
    }
  }

  // Milestone coloring with fiscal period support
  if (colorByAttribute) {
    const colors = {};
    const historyEntries = initiatives.flatMap((initiative) => initiative.history || []);

    if (colorByAttribute === 'Work starting date') {
      result.forEach((milestone) => {
        const startDate = milestone.startDate
          ? moment(milestone.startDate).format('YYYY-MM-DD')
          : 'No Date';
        // Check for invalid date (year < 2000)
        const year = parseInt(startDate.substring(0, 4));
        const displayDate = (year && year < 2000) ? 'Not Set' : startDate;
        if (!colors[displayDate]) {
          colors[displayDate] = getRandomColor();
        }
      });
    }
    // Milestone Start Date Fiscal Periods
    else if (colorByAttribute === 'milestoneStartYear') {
      result.forEach((milestone) => {
        const year = getMilestoneStartYear(milestone);
        const summary = year || 'Not Set';
        if (!colors[summary]) {
          colors[summary] = getRandomColor();
        }
      });
    }
    else if (colorByAttribute === 'milestoneStartQuarter') {
      result.forEach((milestone) => {
        const quarter = getMilestoneStartQuarter(milestone);
        const summary = quarter || 'Not Set';
        if (!colors[summary]) {
          colors[summary] = getRandomColor();
        }
      });
    }
    else if (colorByAttribute === 'milestoneStartMonth') {
      result.forEach((milestone) => {
        const month = getMilestoneStartMonth(milestone);
        const summary = month || 'Not Set';
        if (!colors[summary]) {
          colors[summary] = getRandomColor();
        }
      });
    }
    else if (colorByAttribute === 'milestoneStartWeek') {
      result.forEach((milestone) => {
        const week = getMilestoneStartWeek(milestone);
        const summary = week || 'Not Set';
        if (!colors[summary]) {
          colors[summary] = getRandomColor();
        }
      });
    }
    else if (colorByAttribute === 'Milestone completion date') {
      result.forEach((milestone) => {
        const endDate = milestone.endDate
          ? moment(milestone.endDate).format('YYYY-MM-DD')
          : 'No Date';
        const year = parseInt(endDate.substring(0, 4));
        const displayDate = (year && year < 2000) ? 'Not Set' : endDate;
        if (!colors[displayDate]) {
          colors[displayDate] = getRandomColor();
        }
      });
    }
    // Milestone End Date Fiscal Periods
    else if (colorByAttribute === 'milestoneEndYear') {
      result.forEach((milestone) => {
        const year = getMilestoneEndYear(milestone);
        const summary = year || 'Not Set';
        if (!colors[summary]) {
          colors[summary] = getRandomColor();
        }
      });
    }
    else if (colorByAttribute === 'milestoneEndQuarter') {
      result.forEach((milestone) => {
        const quarter = getMilestoneEndQuarter(milestone);
        const summary = quarter || 'Not Set';
        if (!colors[summary]) {
          colors[summary] = getRandomColor();
        }
      });
    }
    else if (colorByAttribute === 'milestoneEndMonth') {
      result.forEach((milestone) => {
        const month = getMilestoneEndMonth(milestone);
        const summary = month || 'Not Set';
        if (!colors[summary]) {
          colors[summary] = getRandomColor();
        }
      });
    }
    else if (colorByAttribute === 'milestoneEndWeek') {
      result.forEach((milestone) => {
        const week = getMilestoneEndWeek(milestone);
        const summary = week || 'Not Set';
        if (!colors[summary]) {
          colors[summary] = getRandomColor();
        }
      });
    }
    else if (colorByAttribute === 'Planning summary (simplified)') {
      result.forEach((milestone) => {
        const summary = getSimplifiedPlanningSummary(milestone);
        if (!colors[summary]) {
          colors[summary] = getRandomColor();
        }
      })
    }
    else if (
      colorByAttribute === 'Change in Milestone completion date (binned, current vs last week)'
    ) {
      result.forEach((milestone) => {
        const milestoneEndDate = milestone.endDate ? new Date(milestone.endDate) : null;
        const status = milestone.status;
        let binValue = '<not set>';

        if (status === 'Completed') {
          binValue = 'Unchanged';
        } else if (milestoneEndDate) {
          const timeDifference = milestoneEndDate.getTime() - new Date().getTime();
          const daysDifference = Math.ceil(timeDifference / (1000 * 3600 * 24));

          if (daysDifference < 0) {
            binValue = 'Accelerated';
          } else if (daysDifference === 0) {
            binValue = 'Unchanged';
          } else if (daysDifference >= 1 && daysDifference <= 7) {
            binValue = 'Delayed (1 to 7 days)';
          } else if (daysDifference >= 8 && daysDifference <= 14) {
            binValue = 'Delayed (8 to 14 days)';
          } else if (daysDifference >= 15 && daysDifference <= 30) {
            binValue = 'Delayed (15 to 30 days)';
          } else if (daysDifference > 30) {
            binValue = 'Delayed (more than 30 days)';
          }
        }
        if (!colors[binValue]) {
          colors[binValue] = getRandomColor();
        }
      });
      setMilestoneColors(colors);
    } else if (colorByAttribute === 'Owner') {
      const ownerNames = {};
      result.forEach((milestone) => {
        const ownerId = milestone.Owner;
        const owner = users?.find((user) => user._id === ownerId);
        const ownerName = owner
          ? `${owner.firstName || ''} ${owner.lastName || ''}`
          : 'Not Assigned';
        if (!ownerNames[ownerName]) {
          ownerNames[ownerName] = getRandomColor();
        }
      });
      Object.assign(colors, ownerNames);
    } else if (colorByAttribute === 'milestoneNumber - name') {
      result.forEach((milestone) => {
        const numberName = `${milestone.milestoneNumber} - ${milestone.name}`;
        if (!colors[numberName]) {
          colors[numberName] = getRandomColor();
        }
      });
    } else if (colorByAttribute === 'Created On') {
      result.forEach((record) => {
        const milestoneNumberForHistory = record.milestoneNumber;
        const updatedOnHistory = historyEntries.find((entry) =>
          entry.action?.includes(
            `Milestone with Number ${milestoneNumberForHistory} has been updated.`
          )
        );
        const updatedOnDate = updatedOnHistory?.timestamp
          ? moment(updatedOnHistory.timestamp).format('YYYY-MM-DD')
          : 'N/A';
        const year = parseInt(updatedOnDate.substring(0, 4));
        const displayDate = (year && year < 2000) ? 'Not Set' : updatedOnDate;
        if (!colors[displayDate]) {
          colors[displayDate] = getRandomColor();
        }
      });
    } else if (colorByAttribute === 'Created by') {
      result.forEach((record) => {
        const createdHistory = historyEntries.find((entry) =>
          entry.action?.includes(`Milestone #${record.name} created`)
        );
        const creatorId = createdHistory?.user;
        const creator = users?.find((u) => u._id === creatorId);
        const creatorName = creator ? `${creator.firstName} ${creator.lastName}` : 'N/A';
        if (!colors[creatorName]) {
          colors[creatorName] = getRandomColor();
        }
      });
    }
    else if (colorByAttribute === 'Updated by') {
      result.forEach((record) => {
        const updatedOnHistory = historyEntries.find((entry) =>
          entry.action?.includes(
            `Milestone with Number ${record.milestoneNumber} has been updated.`
          )
        );
        const updaterId = updatedOnHistory?.user;
        const updater = users?.find((u) => u._id === updaterId);
        const updaterName = updater ? `${updater.firstName} ${updater.lastName}` : 'N/A';
        if (!colors[updaterName]) {
          colors[updaterName] = getRandomColor();
        }
      });
    } else {
      result.forEach((milestone) => {
        const value = milestone[colorByAttribute];
        const key = safeStringify(value);
        if (!colors[key]) {
          colors[key] = getRandomColor();
        }
      });
    }
    setMilestoneColors(colors);
  }

  // Action Item coloring with fiscal period support
  if (colorByAttribute) {
    const colors = {};
    if (colorByAttribute === 'Accountable Workstream') {
      actionResult.forEach((action) => {
        let workstreamName;
        const ownerRole = action.owner?.role?.name;

        if (ownerRole === 'Workstream Sponsor') {
          workstreamName = action.owner?.workstream?.workstreamName;
        } else {
          workstreamName = action.owner?.subworkstream?.workstream?.workstreamName;
        }
        const key = workstreamName || 'No Workstream';
        if (!colors[key]) {
          colors[key] = getRandomColor();
        }
      });
      setActionItemColors(colors);
    }
    else if (colorByAttribute === 'Accountable Subworkstream') {
      const colors = {};
      actionResult.forEach((action) => {
        const subworkstreamName = action?.owner?.subworkstream?.subworkstreamName || 'No Workstream';
        if (!colors[subworkstreamName]) {
          colors[subworkstreamName] = getRandomColor();
        }
      });
      setActionItemColors(colors);
    }
    else if (colorByAttribute === 'Action planning summary') {
      actionResult.forEach((action) => {
        const summary = determinePlanningSummary(action);
        if (!colors[summary]) {
          colors[summary] = getRandomColor();
        }
      });
      setActionItemColors(colors);
    } else if (colorByAttribute === 'owner') {
      actionResult.forEach((action) => {
        const ownerName =
          `${action.owner?.firstName || ''} ${action.owner?.lastName || ''}`.trim() ||
          'Not Assigned';
        if (!colors[ownerName]) {
          colors[ownerName] = getRandomColor();
        }
      });
      setActionItemColors(colors);
    } else if (colorByAttribute === 'Created on') {
      actionResult.forEach((action) => {
        const createdOnDate = action.created ? moment(action.created).format('YYYY-MM-DD') : 'N/A';
        const year = parseInt(createdOnDate.substring(0, 4));
        const displayDate = (year && year < 2000) ? 'Not Set' : createdOnDate;
        if (!colors[displayDate] && displayDate !== 'N/A') {
          colors[displayDate] = getRandomColor();
        }
      });
      setActionItemColors(colors);
    }
    // Action Item Created On Fiscal Periods
    else if (colorByAttribute === 'actionItemCreatedOnYear') {
      actionResult.forEach((action) => {
        const year = getActionItemCreatedOnYear(action);
        const summary = year || 'Not Set';
        if (!colors[summary]) {
          colors[summary] = getRandomColor();
        }
      });
      setActionItemColors(colors);
    }
    else if (colorByAttribute === 'actionItemCreatedOnQuarter') {
      actionResult.forEach((action) => {
        const quarter = getActionItemCreatedOnQuarter(action);
        const summary = quarter || 'Not Set';
        if (!colors[summary]) {
          colors[summary] = getRandomColor();
        }
      });
      setActionItemColors(colors);
    }
    else if (colorByAttribute === 'actionItemCreatedOnMonth') {
      actionResult.forEach((action) => {
        const month = getActionItemCreatedOnMonth(action);
        const summary = month || 'Not Set';
        if (!colors[summary]) {
          colors[summary] = getRandomColor();
        }
      });
      setActionItemColors(colors);
    }
    else if (colorByAttribute === 'actionItemCreatedOnWeek') {
      actionResult.forEach((action) => {
        const week = getActionItemCreatedOnWeek(action);
        const summary = week || 'Not Set';
        if (!colors[summary]) {
          colors[summary] = getRandomColor();
        }
      });
      setActionItemColors(colors);
    }
    else if (colorByAttribute === 'createdBy') {
      actionResult.forEach((action) => {
        const createdByName =
          `${action.createdBy?.firstName || ''} ${action.createdBy?.lastName || ''}` || 'N/A';
        if (!colors[createdByName] && createdByName !== 'N/A') {
          colors[createdByName] = getRandomColor();
        }
      });
      setActionItemColors(colors);
    } else if (colorByAttribute === 'Updated on') {
      actionResult.forEach((action) => {
        const updatedEvent = action.activity?.find((event) =>
          event.event?.includes(`Workstream action ${action.actionItemNumber} is updated`)
        );
        const updatedOnDate = updatedEvent?.eventDate
          ? moment(updatedEvent.eventDate).format('YYYY-MM-DD')
          : 'N/A';
        const year = parseInt(updatedOnDate.substring(0, 4));
        const displayDate = (year && year < 2000) ? 'Not Set' : updatedOnDate;
        if (!colors[displayDate] && displayDate !== 'N/A') {
          colors[displayDate] = getRandomColor();
        }
      });
      setActionItemColors(colors);
    }
    // Action Item Updated On Fiscal Periods
    else if (colorByAttribute === 'actionItemUpdatedOnYear') {
      actionResult.forEach((action) => {
        const year = getActionItemUpdatedOnYear(action);
        const summary = year || 'Not Set';
        if (!colors[summary]) {
          colors[summary] = getRandomColor();
        }
      });
      setActionItemColors(colors);
    }
    else if (colorByAttribute === 'actionItemUpdatedOnQuarter') {
      actionResult.forEach((action) => {
        const quarter = getActionItemUpdatedOnQuarter(action);
        const summary = quarter || 'Not Set';
        if (!colors[summary]) {
          colors[summary] = getRandomColor();
        }
      });
      setActionItemColors(colors);
    }
    else if (colorByAttribute === 'actionItemUpdatedOnMonth') {
      actionResult.forEach((action) => {
        const month = getActionItemUpdatedOnMonth(action);
        const summary = month || 'Not Set';
        if (!colors[summary]) {
          colors[summary] = getRandomColor();
        }
      });
      setActionItemColors(colors);
    }
    else if (colorByAttribute === 'actionItemUpdatedOnWeek') {
      actionResult.forEach((action) => {
        const week = getActionItemUpdatedOnWeek(action);
        const summary = week || 'Not Set';
        if (!colors[summary]) {
          colors[summary] = getRandomColor();
        }
      });
      setActionItemColors(colors);
    }
    else if (colorByAttribute === 'UpdatedBy') {
      actionResult.forEach((action) => {
        const updatedEvent = action.activity?.find((event) =>
          event.event?.includes(`Workstream action ${action.actionItemNumber} is updated`)
        );
        const updatedOnUser = updatedEvent?.owner ? `${updatedEvent?.owner.firstName} ${updatedEvent?.owner.lastName}` : '<not set>';
        if (!colors[updatedOnUser] && updatedOnUser !== 'N/A') {
          colors[updatedOnUser] = getRandomColor();
        }
      });
      setActionItemColors(colors);
    }
    else {
      actionResult.forEach((action) => {
        const value = action[colorByAttribute];
        const key = safeStringify(value);
        if (!colors[key]) {
          colors[key] = getRandomColor();
        }
      });
      setActionItemColors(colors);
    }
  }
};

export default handleColoring;